import { generateAboutURL } from "../../../src/services/url";
import {
  CURRENCY,
  LOGO_URL,
  LOGO_AU_STACKED,
  ACCCOUNT_FEES,
  EVENT_HANDLERS,
  LOCATION,
} from "../../constants";
import {
  getInstallment,
  isPromotionLengthValid,
  getTitles,
  createQueryString,
} from "./utils";

export const CustomImage = ({
  merchantId = "",
  currency = CURRENCY.AUD,
  stackedLogo,
  price,
  paymentOption,
  promotionMonths,
  productName,
  allowPriceBreakdown,
}) => {
  const aboutURL = generateAboutURL(
    merchantId,
    currency,
    createQueryString(
      paymentOption,
      price,
      promotionMonths,
      allowPriceBreakdown,
      productName,
      LOCATION.WIDGET
    )
  );
  const logoURL = LOGO_URL[currency];

  if (Boolean(stackedLogo) && currency === "AUD") {
    return `
    <!-- Latitude Interest Free Image Snippet - Start -->
    <span>
      <a id="lat-find-out" target="_blank" onclick="${EVENT_HANDLERS.LEARN_MORE_CLICK}('${aboutURL}')" style="display:inline-block; padding: 10px 0; text-decoration:underline; font-weight:bold; font-size:12px; cursor:pointer; color:#3a3a3a;">
      <img style="height:50px;" src="${LOGO_AU_STACKED}" />
      </a>
    </span>
    <!-- Latitude Interest Free Image Snippet - End -->
  `;
  }

  return `
  <!-- Latitude Interest Free Image Snippet - Start -->
  <span>
    <a target="_blank" id="lat-find-out" onclick="${
      EVENT_HANDLERS.LEARN_MORE_CLICK
    }('${aboutURL}')" style="display:inline-block; padding: 10px 0; text-decoration:underline; font-weight:bold; font-size:12px; cursor:pointer; color:inherit;">
       <img style="${
         currency === "AUD" ? `height:22px;` : `height:28px;`
       }" src="${logoURL}" />
    </a>
  </span>
  <!-- Latitude Interest Free Image Snippet - End -->
  `;
};

// COPY CONTAINER
export const CustomCopy = ({
  currency = CURRENCY.AUD,
  price,
  paymentOption,
  allowPriceBreakdown,
  defaultWidget,
  promotionMonths,
}) => {
  const { amount, length } = getInstallment(price, promotionMonths);
  const accountFees = ACCCOUNT_FEES[currency];

  const { FALLBACK_TITLE, LEGACY_TITLE, PRICE_BREAKDOWN_TITLE } = getTitles({
    length,
    amount,
    accountFees,
    price,
    currency,
    defaultWidget,
  });

  const title = allowPriceBreakdown
    ? PRICE_BREAKDOWN_TITLE
    : isPromotionLengthValid(length)
    ? FALLBACK_TITLE
    : LEGACY_TITLE;

  return `
    <!-- Latitude Interest Free Copy Snippet - Start -->
    <div style="font-size: 14px; margin: 10px 0px; font-weight:450; display: flex; flex-wrap: wrap; align-items: center">
      ${title}
    </div>
    <!-- Latitude Interest Free Copy Snippet - End -->
`;
};

export const CustomLink = ({
  merchantId = "",
  currency = CURRENCY.AUD,
  price,
  paymentOption,
  promotionMonths,
  productName,
  allowPriceBreakdown,
}) => {
  const aboutURL = generateAboutURL(
    merchantId,
    currency,
    createQueryString(
      paymentOption,
      price,
      promotionMonths,
      allowPriceBreakdown,
      productName,
      LOCATION.WIDGET
    )
  );

  return `
  <!-- Latitude Interest Free Link Snippet - Start -->
  <div style="font-size: 14px; margin: 10px 0px; font-weight:450; display: flex; flex-wrap: wrap; align-items: center">
    <span style="white-space:nowrap;">
    <a id="lat-find-out" style="text-decoration:underline; cursor:pointer; color:#8d8d8d;" target="_blank" onclick="${EVENT_HANDLERS.LEARN_MORE_CLICK}('${aboutURL}')">
    Learn more
    </a>
  </span>
  </div>
  <!-- Latitude Interest Free Link Snippet - End -->
  `;
};
